import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { selectActiveMatchEvents, selectMatch } from '../../features/match/matchSlice';
import { MatchStatus } from '../../enums/matchStatus';
import { FormattedMessage } from 'react-intl';
import StyledMatchSummary from './StyledMatchSummary';
import {
  inputSliceActions,
  selectActiveEventTypeId,
  selectMatchSummaryEventCheckbox,
} from '../../features/input/inputSlice';
import Checkbox from '../../atoms/input/Checkbox';
import { MatchEventType } from '../../enums/matchEventType';

const EventSummary: React.FC = () => {
  const match = useSelector(selectMatch);
  const dispatch = useDispatch();
  let matchSummaryChecked = useSelector(selectMatchSummaryEventCheckbox);
  const activeMatchEventTypeId = useSelector(selectActiveEventTypeId);
  const activeMatchEvents = useSelector(selectActiveMatchEvents);
  if (activeMatchEventTypeId == MatchEventType.MATCH_SUMMARY) {
    matchSummaryChecked = true;
  }
  let hasMatchSummary = false;
  if (match.matchEvents) {
    match.matchEvents.forEach((matchEvent) => {
      if (matchEvent.matchEventTypeId === MatchEventType.MATCH_SUMMARY) {
        let isActive = false;
        if (activeMatchEvents) {
          activeMatchEvents.forEach((activeMatchEvent) => {
            if (activeMatchEvent.id === matchEvent.id) {
              isActive = true;
            }
          });
        }
        if (!isActive) {
          hasMatchSummary = true;
        }
      }
    });
  }

  const check = () => {
    dispatch(inputSliceActions.setMatchSummaryEventCheckbox(!matchSummaryChecked));
  };

  if (
    !hasMatchSummary &&
    match.matchStatusId === MatchStatus.PLAYED &&
    (activeMatchEventTypeId == MatchEventType.COMMENT || activeMatchEventTypeId == MatchEventType.MATCH_SUMMARY)
  ) {
    return (
      <StyledMatchSummary>
        <div>
          <FormattedMessage id="toggles.matchSummary" />
        </div>
        <div>
          <Checkbox checked={matchSummaryChecked} onChange={check} disabled={matchSummaryChecked} />
        </div>
      </StyledMatchSummary>
    );
  }
  return null;
};

export default EventSummary;
